module.exports = __webpack_public_path__ + "img/qy (48).7107107e.jpg";